import React from 'react';

class FormatoSimplificado536892PlanGold_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 536892 Plan Gold';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1345224_R_GOLD_2022_V1.pdf?alt=media&token=1f919512-cb6d-450e-bb7f-fbc0a418171a';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado536892PlanGold_pdf